import type { BanDich } from '../../types';
import type { viRpaDanhBa } from './danh-ba.vi';

export const enRpaDanhBa: Pick<BanDich, keyof typeof viRpaDanhBa> = {
  rpaDanhBa: {
    moTa: 'Your organisation’s users, OpenCore roles, online status and RPA Client.',
    tabUser: 'Users',
    tabRole: 'Roles',
    nguon: 'Source: OpenCore',
    xem: 'View details',
    sua: 'Edit',
    khoa: 'Lock user',
    moKhoa: 'Unlock user',
    xoaUser: 'Delete user',
    xoaRole: 'Delete role',
    taoUser: 'Create user',
    taoRole: 'Create role',
    rongLoc: 'No rows match the filters',
    giayTruoc: '{{so}} s ago',
    phutTruoc: '{{so}} min ago',
    chuaCoRole: 'No role',
    themRole: '+{{so}}',
    roleKhongDoc: 'Could not read roles',
    kpiTong: 'Users loaded',
    kpiEnabled: 'Enabled',
    kpiOnline: 'Online',
    kpiDisabled: 'Disabled',
    kpiRpa: 'With RPA Client',
    timUser: 'Search name / username / email / ID / role...',
    locTrangThai: 'Filter by status',
    moiTrangThai: 'All statuses',
    locValidated: 'Filter by Validated',
    moiValidated: 'Any Validated',
    daValidated: 'Validated',
    chuaValidated: 'Not validated',
    locRole: 'Filter by role',
    moiRole: 'All roles',
    loc: {
      enabled: 'Active (Enabled)',
      disabled: 'Disabled',
      online: 'Recently online',
      rpa: 'Has RPA heartbeat',
      unvalidated: 'Not validated',
    },
    daTaiUser: '{{so}} users · up to 500 users per read',
    rongUser: 'OpenCore has no users yet',
    rongUserMoTa: 'Create a user to grant licences and let Robots sign in to OpenRPA.',
    cotUser: 'Name / Username / Email',
    cotId: 'User ID',
    cotRole: 'Roles',
    cotTrangThai: 'Status',
    cotValidated: 'Validated',
    cotEmailValidated: 'Email Validated',
    cotLastSeen: 'Last Seen',
    cotRpaHeartbeat: 'RPA Heartbeat',
    cotPhienBan: 'Version',
    openRpaVer: 'OpenRPA {{ver}}',
    clientVer: 'Client {{ver}}',
    user: {
      online: 'Online',
      offline: 'Offline',
      disabled: 'Disabled',
      co: 'Yes',
      chua: 'Not yet',
    },
    baoVe: {
      service: 'The FOXAI service account used to connect to OpenCore — it cannot be locked or deleted.',
      self: 'This user is the OpenCore account you are connected as — it cannot be deleted.',
    },
    ngan: {
      openRpa: 'OpenRPA Version',
      client: 'Client Version',
      taoLuc: 'Created',
      suaLuc: 'Last updated',
      roleTrucTiep: 'Roles (direct)',
      khongCoRole: 'No direct roles.',
      thanhVien: 'Members ({{so}})',
      chuaCoThanhVien: 'No members yet.',
    },
    form: {
      taoTieuDe: 'Create OpenCore user',
      suaTieuDe: 'Edit user · {{ten}}',
      ten: 'Display name',
      username: 'Username / Email',
      usernameGoiY: 'Used to sign in to OpenCore. 3–128 characters: lower-case letters, digits and . _ @ + -',
      email: 'Email',
      matKhau: 'Password',
      matKhauGoiY: 'At least {{min}} characters.',
      xacNhanMatKhau: 'Repeat password',
      enabled: 'Enabled',
      validated: 'Validated',
      emailValidated: 'Email Validated',
      role: 'Roles',
      chonRole: 'Pick roles...',
      roleGoiY: 'Add or remove roles. The RPA licence role is synced from the RPA licences screen.',
      roleChuaBiet: 'The user’s current roles could not be read, so roles cannot be edited. Select Refresh and try again.',
      quaLicense: '(via licence)',
      loiTen: 'Enter a display name.',
      loiUsernameThieu: 'Enter a username / email.',
      loiUsername: 'Username: 3–128 characters, letters, digits and . _ @ + - only',
      loiEmail: 'This email is not valid, for example name@company.com.',
      loiMatKhauNgan: 'The password needs at least {{min}} characters.',
      loiMatKhauDai: 'The password can have at most {{max}} characters.',
      loiXacNhan: 'The passwords do not match. Repeat the password exactly.',
      tao: 'Create user',
      luu: 'Save user',
      daTao: 'Created user {{ten}}.',
      daLuu: 'Saved user {{ten}}.',
    },
    admin: {
      tieuDe: 'Add to the admins role?',
      than: '{{ten}} will get very high administrative rights on your organisation’s OpenCore.',
      nut: 'Add to admins',
    },
    xacNhan: {
      khoaTieuDe: 'Lock user {{ten}}?',
      khoaThan: 'The user is blocked from starting new workflow runs through Native and their licences are re-synced. Workflow sessions already running are not cancelled.',
      moKhoaTieuDe: 'Unlock user {{ten}}?',
      moKhoaThan: 'The user becomes active again. Run access still depends on a licence in effect.',
      xoaTieuDe: 'Delete user {{ten}}?',
      xoaThan: 'The user is deleted from OpenCore and removed from every role. This cannot be undone.',
      daKhoa: 'Locked user {{ten}}.',
      daMoKhoa: 'Unlocked user {{ten}}.',
      daXoa: 'Deleted user {{ten}}.',
      xoaRoleTieuDe: 'Delete role {{ten}}?',
      xoaRoleThan: '{{so}} members lose the rights from this role. This cannot be undone.',
      daXoaRole: 'Deleted role {{ten}}.',
    },
    kpiRole: 'Total roles',
    kpiRoleHeThong: 'System roles',
    kpiRoleTuyChinh: 'Custom roles',
    timRole: 'Search role name / description / ID...',
    roleGoiY: 'Only roles your organisation’s OpenCore service account can read are shown.',
    rongRole: 'No roles could be read',
    rongRoleMoTa: 'Create a role to group users and grant rights on OpenCore.',
    cotTenRole: 'Role name',
    cotThanhVien: 'Members',
    cotMoTa: 'Description',
    cotLoai: 'Type',
    roleHeThongKhongXoa: 'System roles cannot be deleted.',
    role: {
      heThong: 'System',
      license: 'RPA licence',
      rpa: 'RPA',
      tuyChinh: 'Custom',
    },
    roleForm: {
      taoTieuDe: 'Create OpenCore role',
      suaTieuDe: 'Edit role · {{ten}}',
      ten: 'Role name',
      tenHeThong: 'System roles cannot be renamed.',
      moTa: 'Description',
      thanhVien: 'Members',
      chonUser: 'Pick users...',
      thanhVienLicense: 'Members of this role are synced by RPA licences — assign them on the RPA licences screen.',
      thieuQuyenUser: 'You need permission to read OpenCore users to pick members.',
      adminsGoiY: 'Members of the admins role have very high administrative rights on OpenCore.',
      loiTen: 'Enter a role name.',
      tao: 'Create role',
      luu: 'Save role',
      daTao: 'Created role {{ten}}.',
      daLuu: 'Saved role {{ten}}.',
    },
  },
};
